const breadcrumbDictionary = (item: string) => {
  switch (item) {
    case "administrator":
      return "administrator";
    case "ticket":
      return "ticket";
    case "user":
      return "user";
    case "schoolSuperAgent":
      return "superAgent";
    case "education-province":
      return "provinceEducation";
    case "city-municipality":
      return "cityEducation";
    case "taxi":
      return "تاکسی";
    case "agent":
      return "آژانس";
    case "passenger":
      return "مسافر";
    case "driver":
      return "driver";
    case "super-agent":
      return "superAgent";
    case "superAgent":
      return "superAgent";
    case "financial":
      return "financial";
    case "invoice":
      return "invoice";
    case "transaction":
      return "transactions";
    case "travel":
      return "سفر ها";
    case "financial-group":
      return "financialGroup";
    case "travelGroup":
      return "گروه سفر";
    case "transactionExcel":
      return "اکسل تراکنش ها";
    case "delivery":
      return "پیک";
    case "withdrawal":
      return "withdrawal";
    case "school":
      return "school";
    case "company":
      return "company";
    case "parent":
      return "parent";
    case "service":
      return "service";
    case "student":
      return "student";
    case "messaging":
      return "پیامرسانی";
    case "sms":
      return "پیامک";
    case "history":
      return "history";
    case "notification":
      return "notification";
    case "parents":
      return "parent";
    case "other":
      return "other";
    case "add-city":
      return "addCity";
    case "municipality":
      return "municipality";
    case "government-ship":
      return "governmentShip";
    case "debts":
      return "debts";
    case "debt-to-driver":
      return "debtsToDriver";
    case "absent":
      return "absent";
    case "company-factor":
      return "companyFactor";
    case "parent-transaction":
      return "parentTransaction";
    case "driver-transaction":
      return "driverTransaction";
    case "pay-to-driver":
      return "payToDriver";
    case "pending":
      return "pending";
    case "rejected":
      return "rejected";
    case "approve-parent-transaction":
      return "approveParentTransaction";
    case "online-transaction":
      return "onlineTransaction";

    case 'city'        : return 'شهر'   ;
    case 'area'        : return 'منطقه' ;
    case 'province'    : return 'استان' ;
    case 'location'    : return 'مکان‌ها';
    case 'neighborhood': return 'محله'  ;

    default:
      break;
  }
};
export default breadcrumbDictionary;
